import { render, staticRenderFns } from "./OrderFormDetails.vue?vue&type=template&id=38992dfe&"
import script from "./OrderFormDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderFormDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFormDetails.vue?vue&type=style&index=0&id=38992dfe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports